<div class="row" *transloco="let t; prefix: 'fuelReconciliation'">
  <div class="col-lg-3 col-md-6 col-sm-12">
    <app-kpi-widget [title]="t('kpi.numberOfUnreconciled')" icon="assets/images-fuel/efficencyNewIcon.svg"
      [isLoading]="isLoading" [totalValue]="unreconciledKpiSummary.value"
      [percentageDifference]="unreconciledKpiSummary.differenceInPercentage"
      [costDifference]="unreconciledKpiSummary.totalCostDifference"
      [costDifferenceFormatter]="formatUnreconciledDifference.bind(this)"
      [valueFormatter]="formatUnreconciledValue.bind(this)" [widgetDisabled]="false"
      [isUptrendPositive]="isUptrend" [dropdownEnabled]="false" [hasCost]="false" [hasError]="hasError"
      [errorMessage]="errorMessage">
    </app-kpi-widget>
  </div>

  <div class="col-lg-3 col-md-6 col-sm-12">
    <app-kpi-widget [title]="t('kpi.fuelSlipLitres')" icon="assets/images-fuel/fulePampIcon.svg" [isLoading]="isLoading"
      [totalValue]="fuelSlipKpiSummary.value" [percentageDifference]="fuelSlipKpiSummary.differenceInPercentage"
      [costDifference]="fuelSlipKpiSummary.totalCostDifference" [valueFormatter]="formatValue.bind(this)"
      [costFormatter]="formatCost.bind(this)" [costDifferenceFormatter]="formatCostDifference.bind(this)"
      [widgetDisabled]="false" [totalCost]="fuelSlipKpiSummary.totalCost"
      [isUptrendPositive]="isUptrend" [dropdownEnabled]="false" [hasCost]="true" [hasError]="hasError"
      [errorMessage]="errorMessage">
    </app-kpi-widget>
  </div>

  <div class="col-lg-3 col-md-6 col-sm-12">
    <app-kpi-widget [title]="t('kpi.probeLitres')" icon="assets/images-fuel/fuelDecrslIconNew.svg" [isLoading]="isLoading"
      [totalValue]="fuelProbeKpiSummary.value" [percentageDifference]="fuelProbeKpiSummary.differenceInPercentage"
      [costDifference]="fuelProbeKpiSummary.totalCostDifference" [valueFormatter]="formatValue.bind(this)"
      [costFormatter]="formatCost.bind(this)" [costDifferenceFormatter]="formatCostDifference.bind(this)"
      [widgetDisabled]="false" [totalCost]="fuelProbeKpiSummary.totalCost"
      [isUptrendPositive]="isUptrend" [dropdownEnabled]="false" [hasCost]="true" [hasError]="hasError"
      [errorMessage]="errorMessage">
    </app-kpi-widget>
  </div>

  <div class="col-lg-3 col-md-6 col-sm-12">
    <app-kpi-widget [title]="t('kpi.varianceLitres')" icon="assets/images-fuel/totalTripIconNew.svg"
      [isLoading]="isLoading" [totalValue]="varianceKpiSummary.value"
      [percentageDifference]="varianceKpiSummary.differenceInPercentage" [costDifference]="varianceKpiSummary.totalCostDifference"
      [valueFormatter]="formatValue.bind(this)" [costFormatter]="formatCost.bind(this)"
      [costDifferenceFormatter]="formatCostDifference.bind(this)" [widgetDisabled]="false"
      [totalCost]="varianceKpiSummary.totalCost" [isUptrendPositive]="isUptrend" [dropdownEnabled]="false"
      [hasCost]="true" [hasError]="hasError" [errorMessage]="errorMessage">
    </app-kpi-widget>
  </div>
</div>